module.exports = __webpack_public_path__ + "img/map_default.c463d479.jpg";